export const validation = {
  status: 'Status is required',
  order: 'Order is required',
  question: 'Question is required',
  description: 'Description is required',
};
